var render = function render(_c,_vm){return _c(_vm.$options.components.FunctionalFormulaArrayItems,_vm._g({tag:"component",staticClass:"grid-view__cell grid-view-array-field",class:[_vm.data.staticClass, _vm.data.class],attrs:{"field":_vm.props.field,"value":_vm.props.value,"selected":_vm.props.selected}},_vm.listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }